var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgBookmarkFill = function SvgBookmarkFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.183l-5.135 3.668A.8.8 0 015.6 19.2V6.4A2.4 2.4 0 018 4h8a2.4 2.4 0 012.4 2.4v12.8a.8.8 0 01-1.265.651L12 16.183z"
  })));
};
export default SvgBookmarkFill;